import React, { Suspense, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentVersion } from '../../../utils/version';
import { UtLoading } from '../primitives';
import { UtHeader } from './UtHeader';
import { UtBottomTabs } from './UtBottomTabs';
import { UtAdminShell } from '../admin/UtAdminShell';

/**
 * Ultimate Team app shell: header, centred 1200px main, footer and (below
 * 834px) the bottom tab bar. /admin routes use UtAdminShell instead.
 */
export const UtShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  useEffect(() => {
    document.documentElement.classList.add('ut-active');
    return () => document.documentElement.classList.remove('ut-active');
  }, []);

  if (isAdmin) return <UtAdminShell>{children}</UtAdminShell>;

  return (
    <div className="ut-root flex min-h-screen flex-col bg-ut-bg2 font-ut-body text-ut-ink">
      <UtHeader />
      <main
        className="mx-auto flex w-full max-w-[1200px] flex-1 flex-col gap-[22px] px-4 pb-28 pt-[18px] ut-md:px-7 ut-md:pb-9 ut-md:pt-6 lg:px-8 lg:pb-10 lg:pt-7"
      >
        {/* Suspense sits below the header so lazy routes never unmount the nav. */}
        <Suspense fallback={<UtLoading />}>{children}</Suspense>
      </main>
      <footer className="hidden border-t border-ut-line px-4 py-5 text-center text-xs text-ut-mut ut-md:block">
        © {new Date().getFullYear()} Wednesday Night Football ·{' '}
        <Link to="/changelog" className="hover:text-ut-ink">
          v{getCurrentVersion()}
        </Link>
      </footer>
      <UtBottomTabs />
    </div>
  );
};
